import { render, staticRenderFns } from "./ContactDetailsList.vue?vue&type=template&id=39a02aa4&scoped=true&"
import script from "./ContactDetailsList.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsList.vue?vue&type=style&index=0&id=39a02aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a02aa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
